import { render, staticRenderFns } from "./createCompetencyModal.vue?vue&type=template&id=40390233&"
import script from "./createCompetencyModal.vue?vue&type=script&lang=js&"
export * from "./createCompetencyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports